<template>
    <v-select label="경매유형" v-model="mode_auction" :items="items" v-bind="attrs_input" />
</template>

<script>
import { attrs_input, WORK_AUCTION_MODES } from "@/assets/variables";
const { NULL, PRIVATE } = WORK_AUCTION_MODES;
const items = Object.values(WORK_AUCTION_MODES);

export default {
    props: {
        value: { type: Object },
    },
    data: () => ({
        attrs_input,

        items,
        mode_auction: WORK_AUCTION_MODES.NULL.value,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        "value.mode_auction"() {
            this.sync();
        },
        mode_auction() {
            if (this.mode_auction !== this.value?.mode_auction) {
                if ([NULL.value, PRIVATE.value].includes(this.mode_auction))
                    this.$emit("input", {
                        ...this.value,
                        mode_auction: this.mode_auction,
                        _program: null,
                        program: null,
                        group: null,
                        duration_auction: {
                            startsAt: null,
                            endsAt: null,
                        },
                    });
                else
                    this.$emit("input", {
                        ...this.value,
                        mode_auction: this.mode_auction,
                    });
            }
        },
    },
    methods: {
        sync() {
            if (this.value.mode_auction !== this.mode_auction) this.mode_auction = this.value.mode_auction;
        },
    },
};
</script>

<style></style>
